const cache = new Map<string, Promise<void>>();

export const loadScriptOnce = (src: string): Promise<void> => {
  if (typeof window === "undefined") return Promise.resolve();
  const cached = cache.get(src);
  if (cached) return cached;

  const existing = document.querySelector<HTMLScriptElement>(
    `script[src="${src}"]`,
  );
  if (existing && existing.dataset.loaded === "true") {
    const resolved = Promise.resolve();
    cache.set(src, resolved);
    return resolved;
  }

  const promise = new Promise<void>((resolve, reject) => {
    const script = existing ?? document.createElement("script");
    if (!existing) {
      script.src = src;
      script.async = true;
      document.head.appendChild(script);
    }
    script.addEventListener("load", () => {
      script.dataset.loaded = "true";
      resolve();
    });
    script.addEventListener("error", () => {
      cache.delete(src);
      reject(new Error(`Failed to load script: ${src}`));
    });
  });

  cache.set(src, promise);
  return promise;
};

export const SDK_SRC = {
  smallcase: "https://gateway.smallcase.com/scdk/2.0.0/scdk.js",
  digio: "https://app.digio.in/sdk/v11/digio.js",
  cashfree: "https://sdk.cashfree.com/js/v3/cashfree-2023.03.07.js",
} as const;
